var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeroduesKonfigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5846",
    "data-name": "Group 5846",
    transform: "translate(22683 15773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5845",
    "data-name": "Group 5845",
    transform: "translate(-22684 -15777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5844",
    "data-name": "Group 5844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5840",
    "data-name": "Group 5840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8190",
    "data-name": "Path 8190",
    d: "M16.67,13.13A4.651,4.651,0,0,1,19,17v3h3a1,1,0,0,0,1-1V17C23,14.82,19.43,13.53,16.67,13.13Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5841",
    "data-name": "Group 5841"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(5 4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5842",
    "data-name": "Group 5842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8191",
    "data-name": "Path 8191",
    d: "M15,12a4,4,0,0,0,0-8,4.178,4.178,0,0,0-1.33.24,5.98,5.98,0,0,1,0,7.52A4.178,4.178,0,0,0,15,12Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5843",
    "data-name": "Group 5843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8192",
    "data-name": "Path 8192",
    d: "M9,13c-2.67,0-8,1.34-8,4v2a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V17C17,14.34,11.67,13,9,13Z",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeroduesKonfigIcon);
export default __webpack_public_path__ + "static/media/perodues_konfig_icon.e4c9fdad16ff8a49ab4e9d933c381a5f.svg";
export { ForwardRef as ReactComponent };